import {initWebComponent} from "@/helpers/web-component-helper";

export class HeaderFilterComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = `
          <div class="btn-group project-actions mt-1 mt-md-0">
            <button type="button" class="btn btn-outline-secondary btn-sm borderless dropdown-toggle popper-header text-transform-none" data-bs-toggle="dropdown" aria-expanded="false">
                  <span class="fa fa-filter navbar-icon"></span>
                  <div class="popper-tooltip" role="tooltip" data-popper-placement="bottom">
                      Filter op
                      <div class="arrow" data-popper-arrow=""></div>
                  </div>
            </button>
            <div class="dropdown-menu  ">
              <h6 class="dropdown-header">Filter op</h6>
              <div id="divFilterButtons"></div>  
            </div>
          </div>`

        initWebComponent(this, template)
    }
}

